import {
  REFINIMENT_AMOUNT_ATTRIBUTES,
  REFINIMENT_CAFFEINE_ATTRIBUTES
} from '@/constants'

export const isAmountAttribute = (attributeId: string) =>
  REFINIMENT_AMOUNT_ATTRIBUTES.includes(attributeId)

export const isCaffeineAttribute = (attributeId: string) =>
  REFINIMENT_CAFFEINE_ATTRIBUTES.includes(attributeId)
